{
    "producedComponentList": [],
    "producedTotalCount": 0,
    "producedErrorsCount": 0,
    "producedSortExpression": null,
    "producedFilterExpression": null,
    "producedColumnsVisiblity": [],
    "allocatedComponentList": [],
    "allocatedTotalCount": 0,
    "allocatedErrorsCount": 0,
    "allocatedSortExpression": null,
    "allocatedFilterExpression": null,
    "allocatedColumnsVisiblity": [],
    "producedPaging": {
        "offset": 50,
        "page": 1
    },
    "allocatedPaging": {
        "offset": 50,
        "page": 1
    },
    "stockPaging": {
        "offset": 50,
        "page": 1
    },
    "producedWidget": {
        "totalValue": 0,
        "totalAmount": 0
    },
    "allocatedWidget": {
        "totalValue": 0,
        "totalAmount": 0
    },
    "stockWidget": {
        "totalValue": 0,
        "totalAmount": 0
    },
    "allocationUnitColumnsConfigration": [
        {
            "allocationUnits": [
                11,
                29,
                14,
                27
            ],
            "columns": [
                "chassisNumber",
                "productIndividualNumber",
                "countryCode",
                "productionDate",
                "invoiceDate",
                "engineVehicle",
                "batteryVehicle",
                "axle",
                "gearboxVehicle",
                "finalAssemblyComponentDeliveryValue",
                "totalValue"
            ]
        },
        {
            "allocationUnits": [
                15,
                18,
                6,
                10
            ],
            "columns": [
                "chassisNumber",
                "productIndividualNumber",
                "countryCode",
                "productionDate",
                "invoiceDate",
                "engineVehicle",
                "batteryVehicle",
                "axle",
                "gearboxVehicle",
                "cab",
                "painted",
                "electricPropVehicle",
                "finalAssemblyComponentDeliveryValue",
                "totalValue"
            ]
        },
        {
            "allocationUnits": [
                26
            ],
            "columns": [
                "chassisNumber",
                "productIndividualNumber",
                "countryCode",
                "productionDate",
                "invoiceDate",
                "engineVehicle",
                "batteryVehicle",
                "axle",
                "gearboxVehicle",
                "cab",
                "gosParts",
                "painted",
                "finalAssemblyComponentDeliveryValue",
                "totalValue"
            ]
        },
        {
            "allocationUnits": [
                28,
                8
            ],
            "columns": [
                "serialNumber",
                "productIndividualNumber",
                "countryCode",
                "productionDate",
                "invoiceDate",
                "finalAssemblyComponentDeliveryValue",
                "totalValue"
            ]
        },
        {
            "allocationUnits": [
                5
            ],
            "columns": [
                "serialNumber",
                "productIndividualNumber",
                "countryCode",
                "productionDate",
                "invoiceDate",
                "finalAssemblyComponentDeliveryValue",
                "totalValue",
                "electricPropVehicle"
            ]
        }
    ],
    "currentUnitColumns": [
        "chassisNumber",
        "productIndividualNumber",
        "countryCode",
        "productionDate",
        "invoiceDate",
        "totalValue"
    ]
}